module.exports = __webpack_public_path__ + "static/media/news-15.a36fb73e.jpg";